import { Injectable } from "@angular/core";
import { UserService } from "@main-services/user.service";
import { TranslationService } from "@core-services/translation.service";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { BestVipLevelPerk } from "@modules/new_account/features/my-best/domain/entities/best-vip-level-perk.model";

export enum UserMembership {
	Normal = "none",
	Gold = "gold",
	Silver = "silver"
}

export interface UserMembershipResponse {
	club_level: string;
}

export interface UserMembershipData {
	clubLevel: string;
}

@Injectable({
	providedIn: "root"
})
export class UserMembershipService {
	public constructor(
		private readonly userService: UserService,
		private readonly translationService: TranslationService
	) {}

	public getMembership$(): Observable<UserMembershipData> {
		return this.userService.getMembershipData$().pipe(
			map((membership: UserMembershipResponse) => ({
				clubLevel: membership.club_level
			}))
		);
	}

	public getGoldOrSilverBenefits(
		vipLevelStatus: string,
		vipLevelNumber?: number,
		isNextBenefit?: boolean
	): BestVipLevelPerk {
		const silverTitle = "best_benefits_silver_member_title";
		const silverDescription = "best_benefits_silver_member_description";
		const goldIcon = "assets/images/gold_club_member.svg";
		const silverIcon = "assets/images/silver_club_member.svg";

		if (
			(!isNextBenefit && vipLevelStatus === UserMembership.Gold) ||
			(isNextBenefit && vipLevelStatus === UserMembership.Silver)
		) {
			return {
				title: this.translationService.translate("best_benefits_gold_member_title_v2"),
				additional_data: {
					description: this.translationService.translate("best_benefits_gold_member_description_v2")
				},
				icon: goldIcon
			};
		}

		if ((!isNextBenefit && vipLevelStatus === UserMembership.Silver) || (isNextBenefit && vipLevelNumber === 4)) {
			return {
				title: this.translationService.translate(silverTitle),
				additional_data: { description: this.translationService.translate(silverDescription) },
				icon: silverIcon
			};
		}
	}
}
